import {
  Button,
  ConfirmationBox,
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  NavGroup,
  OffCanvasLayout,
  Pagination,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { Link } from "react-router-dom";
import useOrder from "./useOrder";
import { FaSort } from "react-icons/fa";
import AddOrder from "./AddOrder";
import AddOldCertificate from "./AddOldCertificate";
import OrderColumn from "../../Global/OrderColumn";
import StockReceipt from "./StockInvoice/StockReceipt";
import AddShop from "./AddShop";
import Filter from "./Filter";
import ExcelUpload from "./ExcelUpload";
import FilterButton from "../../Global/FilterButton";
import ReceiptPdf from "./ReceiptPrint/ReceiptPdf";
import { Table } from "../../Global/Table";

const Order = () => {
  const {
    date,
    handleDateChange,
    // isLoading,
    ordersList,
    tableFields,
    tabNavs,
    isFetching,
    orderState,
    paginationOptions,
    showEditModal,
    stockPrintRef,
    cashReceiptRef,
    inputData,
    handleFilterClose,
    handleFilter,
    handleSearch,
    filterCount,
    handleClearClick,
    handleEditClick,
    handlePagination,
    handlePageSize,
    refetch,
    handleAddShop,
    handleSort,
    handleCloseAddOrderModal,
    handleEditColumnsClick,
    handleAddOrderClick,
    handleDelete,
    handleDeleteModal,
    handleCloseAddShopModal,
    updateOrderFields,
    getRow,
    handlePrintClick,
    handleCloseUploadModal,
    handleAddOldCertificateClick,
  } = useOrder();

  return (
    <>
      <div className="pro-d-flex pro-justify-betwen pro-items-center">
        <HeadingGroup
          title={"Orders"}
          className={`pro-mb-4`}
          buttonTitle={ordersList?.create_permission ? "Add new" : ""}
          handleClick={handleAddOrderClick}
        />
        <div className="pro-d-flex pro-gap-2">
          {ordersList?.create_permission && (
            <button
              className="pro-btn pro-btn-primary no-wrap"
              onClick={handleAddOldCertificateClick}
            >
              Add Old Certificates
            </button>
          )}
          {ordersList?.private_party_permission && (
            <button
              className="pro-btn pro-btn-outline-primary no-wrap"
              onClick={handleAddShop}
            >
              Add Private Party
            </button>
          )}
        </div>
      </div>

      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="pro-mb-4">
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        <div className="row gx-2 gy-2 flex-fill">
          <div className={`col-auto`}>
            <div className="input-wrap">
              <input
                type="text"
                value={inputData}
                onChange={handleSearch}
                placeholder="Search Supplier, Shop, Gli Number, Lot Number"
                className={`pro-input icon-r lg search-input`}
              />
              <span className="pro-icon">
                {<span className="material-symbols-outlined">search</span>}
              </span>
            </div>
          </div>
          <div className={`col-auto`}>
            <DatePickerWithInput
              CalendarOutlineIcon={
                <span className="material-symbols-outlined">
                  calendar_month
                </span>
              }
              range={true}
              initialValue={date}
              onDateChange={handleDateChange}
              datePickerProps={"this_year"}
            ></DatePickerWithInput>
          </div>
          <div className={`col-auto`}>
            <button
              className="pro-btn pro-btn-outline"
              onClick={handleEditColumnsClick}
            >
              Edit Columns
            </button>
          </div>
          <div className={`col-auto`}>
            <FilterButton
              onClick={handleFilter}
              filterCount={filterCount}
              label="Filters"
            />
          </div>
          <div className={`col-auto`}>
            <Button
              className={"pro-btn-link lg pro-px-5"}
              onClick={handleClearClick}
            >
              Clear
            </Button>
          </div>
        </div>
        <Table
          multiSelect={false}
          data={ordersList?.data ?? []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          clear={orderState.clearSelection}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={orderState?.currentPageSize}
          assignable={true}
          handleEdit={handleEditClick}
          handleDelete={handleDeleteModal}
          deletable={ordersList?.delete_permission}
          showCheckBox={true}
          editable={ordersList?.edit_permission}
          assignText={"Print"}
          assignIcon={<span className="material-symbols-outlined">print</span>}
          handleAssign={handlePrintClick}
          stickyActionBtns={true}
          // extraClasssName="table-wrapper tbl-h"
        />

        {ordersList?.data?.length > 0 && (
          <Pagination
            currentPage={orderState?.currentPage}
            totalPageCount={Math.ceil(
              ordersList?.total_count / orderState.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={orderState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected item ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>
        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={ordersList?.fields}
              moduleId={ordersList?.module_id}
              updateData={updateOrderFields}
            />
          </div>
        </ModalLayout>
        <div
          style={{
            position: "fixed",
            opacity: "0",
            visibility: "hidden",
            height: "0",
            width: "0",
          }}
        >
          <StockReceipt stockPrintRef={stockPrintRef} />
          <ReceiptPdf receiptRef={cashReceiptRef} />
        </div>

        <OffCanvasLayout
          show={orderState?.addShopModal}
          handleClose={handleCloseAddShopModal}
          title={"Add Private Party"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddShop />
        </OffCanvasLayout>
        <OffCanvasLayout
          show={orderState?.showFilter}
          handleClose={handleFilterClose}
          title={"Filter"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <Filter />
        </OffCanvasLayout>

        <OffCanvasLayout
          show={orderState?.showAddOrderModal && !orderState?.isOldCertificate}
          handleClose={handleCloseAddOrderModal}
          title={orderState?.isEdit ? "Edit Order" : "Add Order"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddOrder selectedUser={""} refetch={refetch} />
        </OffCanvasLayout>

        <OffCanvasLayout
          show={orderState?.showAddOrderModal && orderState?.isOldCertificate}
          handleClose={handleCloseAddOrderModal}
          title={
            orderState?.isEdit ? "Edit Old Certificate" : "Add Old Certificates"
          }
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddOldCertificate refetch={refetch} />
        </OffCanvasLayout>

        <ModalLayout
          show={orderState?.showUploadModal}
          handleClose={handleCloseUploadModal}
          title={"Upload Documents"}
          closeicon={<span className="material-symbols-outlined"> close </span>}
        >
          <div className="pro-m-5">
            <ExcelUpload />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};
export default Order;
